export default "__VITE_ASSET__Cv0Ye344__"